
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.29291 9.29291L6.70712 7.87869L12 13.1716L17.2929 7.87869L18.7071 9.29291L12 16L5.29291 9.29291Z" fill="currentColor"></path></svg>';export default svg;
    